// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"8f9e286f","400":"1e69d26c"}[chunkId] + ".chunk.js";
};